var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import styles from './Checkbox.scss';
import { any, bool, func, oneOf, string } from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import React from 'react';
import classNames from 'classnames';
import SvgV from '../svg/V';
import WixComponent from '../BaseComponents/WixComponent';
import Label from '../Label/Label';

/** a simple WixStyle checkbox */

var Checkbox = function (_WixComponent) {
  _inherits(Checkbox, _WixComponent);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          _props$id = _props.id,
          id = _props$id === undefined ? uniqueId() : _props$id,
          checked = _props.checked,
          indeterminate = _props.indeterminate,
          disabled = _props.disabled,
          hasError = _props.hasError,
          hover = _props.hover,
          active = _props.active,
          size = _props.size,
          onChange = _props.onChange;


      var classname = classNames((_classNames = {}, _defineProperty(_classNames, styles.wrapper, true), _defineProperty(_classNames, styles.checked, checked), _defineProperty(_classNames, styles.unchecked, !checked), _defineProperty(_classNames, styles.hover, hover), _defineProperty(_classNames, styles.active, active), _defineProperty(_classNames, styles.disabled, disabled), _defineProperty(_classNames, styles.hasError, hasError), _classNames));

      var checkedSymbol = indeterminate ? React.createElement('div', { className: styles.indeterminate }) : React.createElement(SvgV, null);

      return React.createElement(
        'div',
        { className: classname },
        React.createElement('input', { type: 'checkbox', id: id, checked: checked, disabled: disabled, onChange: disabled ? null : onChange }),
        React.createElement(
          Label,
          { 'for': id, appearance: 'T1.1' },
          React.createElement(
            'div',
            { className: classNames(styles.checkbox, styles[size]) },
            React.createElement(
              'div',
              { className: styles.inner },
              checkedSymbol
            )
          ),
          React.createElement(
            'div',
            { className: styles.children },
            this.props.children
          )
        )
      );
    }
  }]);

  return Checkbox;
}(WixComponent);

Checkbox.propTypes = {
  /** used for automatic testing */
  active: bool,
  checked: bool,
  children: any,
  disabled: bool,
  hasError: bool,
  id: string,
  indeterminate: bool,
  /** used for automatic testing */
  hover: bool,
  size: oneOf(['medium', 'large']),
  onChange: func
};
Checkbox.defaultProps = {
  size: 'medium',
  onChange: function onChange() {}
};
Checkbox.displayName = 'Checkbox';


export default Checkbox;
//# sourceMappingURL=Checkbox.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Checkbox/Checkbox.js